import { useLocalize } from 'localize-react';
import React from 'react';

import airplaneSvg from '../airplane.svg';
import dangerSvg from './danger.svg';
import classes from './verifyFlightNumberCard.module.scss';

interface VerifyFlightNumberCardProps {
  flightNumber: string;
  onVerifyFlightNumber: () => void;
}

export const VerifyFlightNumberCard = ({ flightNumber, onVerifyFlightNumber }: VerifyFlightNumberCardProps) => {
  const { translate } = useLocalize();

  return (
    <div className={classes['snackbars-grey']}>
      <div className={classes.title}>
        <div className={classes['icon-l']}>
          <img src={dangerSvg} alt="alert icon" color="#E6BB30" />
        </div>
        <div className={classes.caption}>{translate('fn_VerifyFlightNumberTitle')}</div>
      </div>

      <div className={classes.div}>
        <p className={classes.p}>{translate('fn_VerifyFlightNumberBody1')}</p>
      </div>

      <div className={classes.div}>
        <p className={classes.p}>
          <span className={classes['text-wrapper']}
            dangerouslySetInnerHTML={{ __html: translate('fn_VerifyFlightNumberBody2', { flightNumber }) }} />
        </p>
      </div>

      <button className={classes['buttons-elements']} onClick={() => onVerifyFlightNumber?.()}>
        <div className={classes.body}>
          <div className={classes['icon-l']}>
            <img src={airplaneSvg} alt="airplane icon" />
          </div>
          <div className={classes['caption-2']}>{translate('fn_VerifyFlightNumberButton')}</div>
        </div>
      </button>
    </div>
  );
};
